import React, { useState } from 'react';

function ScenarioDecision({ question, options, correctAnswer, xpReward = 15, coinReward = 3, onComplete }) {
  const [selected, setSelected] = useState(null);
  const [feedback, setFeedback] = useState(null); // 'correct' | 'wrong'
  const [showResult, setShowResult] = useState(false);

  const handleSelect = (opt) => {
    if (selected !== null) return;
    setSelected(opt);
    if (opt === correctAnswer) {
      setFeedback('correct');
      setTimeout(() => {
        setShowResult(true);
        setTimeout(() => onComplete({ xp: xpReward, coins: coinReward }), 1200);
      }, 900);
    } else {
      setFeedback('wrong');
      setTimeout(() => setShowResult(true), 900);
    }
  };

  if (showResult) {
    return (
      <div style={{ textAlign: 'center', padding: 24 }}>
        <h3 style={{ color: feedback === 'correct' ? '#22c55e' : '#ef4444', fontWeight: 800, fontSize: 24, marginBottom: 12 }}>
          {feedback === 'correct' ? 'Correct!' : 'Try Again!'}
        </h3>
        {feedback === 'correct' && <div style={{ fontSize: 18, marginBottom: 10 }}>You earned:</div>}
        {feedback === 'correct' && <div style={{ fontWeight: 700, fontSize: 22, color: '#22c55e' }}>{xpReward} XP</div>}
        {feedback === 'correct' && <div style={{ fontWeight: 700, fontSize: 22, color: '#fbbf24' }}>{coinReward} Coins</div>}
        <button className="gogig-card-btn" style={{ marginTop: 24 }} onClick={() => onComplete({ xp: feedback === 'correct' ? xpReward : 0, coins: feedback === 'correct' ? coinReward : 0 })}>Continue</button>
      </div>
    );
  }

  return (
    <div style={{ padding: 16, minWidth: 280, maxWidth: 340, textAlign: 'center' }}>
      <h3 style={{ fontWeight: 700, fontSize: 20, marginBottom: 12 }}>Scenario Decision</h3>
      <div style={{ color: '#555', marginBottom: 18 }}>{question}</div>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
        {options.map(opt => (
          <button
            key={opt}
            className={`gogig-card-btn${selected === opt ? (opt === correctAnswer ? ' correct' : ' wrong') : '-outline'}`}
            style={{ fontSize: 16, border: feedback && opt === correctAnswer && feedback === 'correct' ? '2px solid #22c55e' : feedback && selected === opt && feedback === 'wrong' ? '2px solid #ef4444' : undefined, background: selected === opt ? (opt === correctAnswer ? '#bbf7d0' : '#fecaca') : undefined, color: selected === opt ? '#222' : undefined, transition: 'all 0.2s' }}
            onClick={() => handleSelect(opt)}
            disabled={selected !== null}
          >
            {opt}
            {feedback && selected === opt && feedback === 'correct' && <span style={{ marginLeft: 8, color: '#22c55e', fontWeight: 700 }}>✅</span>}
            {feedback && selected === opt && feedback === 'wrong' && <span style={{ marginLeft: 8, color: '#ef4444', fontWeight: 700 }}>❌</span>}
          </button>
        ))}
      </div>
    </div>
  );
}

export default ScenarioDecision; 